import $ from 'jquery';
import ko from '@tko/build.knockout';

    function GetColor(value, options) {

        var bg = null;
        if (options && options.customSectors && (options.customSectors.length > 0)) {

            for (var i = options.customSectors.length - 1; i >= 0; i--) {

                var band = options.customSectors[i];
                if ((value >= band.lo) && (value <= band.hi)) {
                    bg = band.color;
                    break;
                }
            };
        }

        if (bg)
            return bg;

        return "var(--good-color)";
    }

    function UpdateGauge(canvasg, value, options) {
        var W = canvasg.width;
        var H = canvasg.height;
        var color = GetColor(value, options);
        var bgcolor = "#edebeb";
        var ctx = canvasg.getContext("2d");

        var min = (options && (options.min != null)) ? options.min : 0;
        var max = (options && (options.max != null)) ? options.max : 100;
        var base = max - min;

        if (base == 0)
            base = 100;

        var radius = W / 3.5;
        var centerx = W / 2;
        var centery = ((H - radius) / 2) + radius; // 4 * H / 5;

        //Clear the canvas everytime a chart is drawn
        ctx.clearRect(0, 0, W, H);

        //Background 360 degree arc
        //ctx.beginPath();
        //ctx.strokeStyle = "#e1dfdf";
        //ctx.lineWidth = 50;
        //ctx.arc((W / 2), (4 * H / 5), (W / 3.5), Math.PI, 0, false); //you can see the arc now
        //ctx.stroke();

        //Background 360 degree arc
        ctx.beginPath();
        ctx.strokeStyle = "#edebeb";
        ctx.lineWidth = W * 50 / 380; //40
        ctx.arc(centerx, centery, radius, Math.PI, 0, false); //you can see the arc now
        ctx.stroke();

        //gauge will be a simple arc
        //Angle in radians = angle in degrees * PI / 180
        var degrees = (value - min) * 180 / base;
        var radians = degrees * Math.PI / 180;
        if (radians == 0)
            radians = 2 * Math.PI;
        ctx.beginPath();
        ctx.strokeStyle = color;

        //ctx.lineWidth = 50;
        //The arc starts from the rightmost end. If we deduct 90 degrees from the angles
        //the arc will start from the topmost end
        ctx.arc(centerx, centery, radius, Math.PI, radians - 180 * Math.PI / 180, false);
        //you can see the arc now
        ctx.stroke();

        //Lets add the text
        ctx.fillStyle = "black";
        ctx.font = "normal normal bold 28px Arial";
        var text = value;
        //Lets center the text
        //deducting half of text width from position x
        var text_width = ctx.measureText(text).width;

        //adding manual value to position y since the height of the text cannot
        //be measured easily. There are hacks but we will keep it manual for now.
        ctx.fillText(text, centerx - text_width / 2, centery);

        text = options.label;
        ctx.font = "normal normal bold 14px Arial";
        text_width = ctx.measureText(text).width;
        ctx.fillText(text, (centerx - (text_width / 2)), (centery + 15));
    }

    function CreateGauge(parent, value, options) {

        var canvasg = document.createElement('canvas');
        canvasg.width = $(parent).width();
        canvasg.height = $(parent).parent().height();
        parent.appendChild(canvasg);

        UpdateGauge(canvasg, value, options);

        //canvasg.addEventListener("resize", function () { UpdateGauge(canvasg, value, options); });

        return canvasg;
    }

    ko.bindingHandlers.justGage = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var options = allBindings().justGageOptions;

            var id = ko.unwrap(allBindings.get('id'));
            var clickhref = ko.unwrap(allBindings.get('clickhref'));
            var value = ko.utils.unwrapObservable(valueAccessor());

            options.parentNode = element;

            var g = new CreateGauge(element, value, options);
            ko.utils.domData.set(element, "justGage.instance" + id, g);

            //var g = new JustGage(options);
            //ko.utils.domData.set(element, "justGage.instance" + id, g);
            if (clickhref) {
                g.onclick = function(event) {
                    location.href = clickhref;
                };
            }
        },
        update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var options = allBindings().justGageOptions;
            options.parentNode = element;
            var id = ko.unwrap(allBindings.get('id'));
            var forceRedraw = ko.unwrap(allBindings.get('forceRedraw'));
            var clickhref = ko.unwrap(allBindings.get('clickhref'));
            var value = ko.utils.unwrapObservable(valueAccessor());

            var g = ko.utils.domData.get(element, "justGage.instance" + id);

            if (!g || forceRedraw) {
                if (g) {
                    $(element).empty();
                }

                g = new CreateGauge(element, value, options);
                ko.utils.domData.set(element, "justGage.instance" + id, g);

                //g = new JustGage(options);
                //ko.utils.domData.set(element, "justGage.instance" + id, g);

                if (clickhref) {
                    g.onclick = function(event) {
                        location.href = clickhref;
                    };
                }
            } else {
                UpdateGauge(g, value, options);
            }

            //g.refresh(ko.utils.unwrapObservable(valueAccessor()), max);
            //g.txtLabel[0].textContent = label;

        }
    };

